export default __webpack_public_path__ + "c274487ff5aa2dbbd92844b7ddfb1696.svg";